export default __webpack_public_path__ + "static/media/greijdanus.3a55c72c.svg";